import React, { Component } from 'react';
import { Row, Col, Card, Icon, Popover, Modal, Divider, Button, notification } from 'antd';
import { ssSessionUtils, ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import AuthTypes from '../AuthTypes';
let targetHostname = '', hasRequestedLogin = false;
const { htmlStorage } = ssSessionUtils,
{ setEnvPrefix } = ssCommonUtils;

// Just an idea...
class FouoBanner extends Component {
    constructor(props) { super(props); }
    render() {
        const { placement } = this.props;
        return (
            <Card
                bodyStyle={{ padding: '2px' }}
                style={placement === 'top'
                    ? { position: 'fixed', width: '100%', top: '0%' }
                    : { position: 'fixed', width: '100%', bottom: '0%' }
                }
            >
                <Row type='flex' justify='space-around' align='middle'>
                    <Col span={4} style={{ textAlign: 'left', fontWeight: 'bold' }}>
                        {'// FOUO'}
                    </Col>
                    <Col span={16} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                        {'Screening Service - Authentication Required'}
                    </Col>
                    <Col span={4} style={{ textAlign: 'right', fontWeight: 'bold' }}>
                        {'FOUO //'}
                    </Col>
                </Row>
            </Card>
        )
    }
}

class BulletInfo extends Component {
    constructor(props) { super(props); }
    render() {
        const { divStyle, title, text } = this.props;
        return (
            <div style={divStyle || {}}>
                <Divider style={{ margin: '0px 0px 10px 0px' }}>
                    <div style={{ marginTop: '5px', fontWeight: 'bold', fontStyle: 'italic' }}>
                        {title}
                    </div>
                </Divider>
                <div>
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col span={23}>
                            <span style={{ lineHeight: '14px' }}>
                                {text}
                            </span>
                        </Col>
                    </Row>
                </div>
            </div>
        );
    }
}

class CloseButton extends Component {
    constructor(props) { super(props); }
    render() {
        const { fn } = this.props;
        return (
            <div>
                <Divider type='horizontal' style={{ margin: '20px 0px 10px 0px' }}/>
                <Row style={{ marginBottom: '-10px' }}>
                    <Col span={24} style={{ textAlign: 'right' }}>
                        <Button
                            size='small'
                            type='primary'
                            icon='check-circle-o'
                            onClick={() => fn('na')}
                            style={{ width: '100px', height: '24px' }}
                        >{'Ok'}</Button>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default class AuthLayout extends Component {
    state = {
        content: null,
        modal: {
            visible: false,
            footer: null,
            style: { top: '33%' }
        }
    }

    constructor(props) {
        super(props);
        const { authType } = props;
        if(authType.indexOf(':') !== -1)
            targetHostname = authType.substring(authType.indexOf(':') + 1, authType.length);
    }

    toggleModalView(modalContent) {
        modalContent = modalContent === 'na'
            ? this.state.content
            : modalContent == null
                ? null
                : modalContent;

        this.setState({...this.state,
            content: modalContent,
            modal: {...this.state.modal, visible: !this.state.modal.visible }
        });
    }

    render() {
        const
        { modal, content } = this.state,
        { authType, background } = this.props,
        noticeBullets = [
            'You have no reasonable expectation of privacy when you use this information system; ' +
            'this includes any communications or data transiting, stored on, originated from or ' +
            'directed to this information system. At any time, and for any lawful government purpose, ' +
            'the government may monitor, intercept, search and seize any communication or data ' +
            'transiting, stored on, originated from or directed to or from this information system.',

            'The government may disclose or use any communications or data transiting, stored on, ' +
            'originated from or directed to or from this information system for any lawful ' +
            'government purpose.',

            'You are NOT authorized to process classified information on this information system.'
        ];
        let divStyle = null;

        return (
            <div style={background.hasOwnProperty('url') ? {
                background: `url(\'${background.url}\')`,
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                position: 'fixed',
                top: '0%',
                bottom: '0%',
                left: '0%',
                right: '0%'
            } : background.hasOwnProperty('color') ? {
                background: background.color,
                position: 'fixed',
                top: '0%',
                bottom: '0%',
                left: '0%',
                right: '0%'
            } : {}}>
                <Modal {...modal}>{content}</Modal>
                <Card
                    style={{
                        backgroundColor: 'white',
                        position: 'fixed',
                        width: '100%',
                        top: '31.4%',
                        minHeight: '290px',
                        maxHeight: '290px'
                    }}
                    bodyStyle={{
                        background: 'white'
                    }}
                >
                    <Row type='flex' justify='space-around' align='middle'>
                        <Col span={12} style={{ textAlign: 'right', opacity: '1' }}>
                            <img src={setEnvPrefix("/analyst/images/DHS-Seal.png")} alt="DHS Seal" style={{ width: '40%', marginRight: '15%' }}/>
                        </Col>
                        <Col span={12} style={{ textAlign: 'left', opacity: '1' }}>
                            <Row style={{ marginLeft: '-10%' }}>
                                <Col span={16}>
                                    <div style={{ marginBottom: '2px' }}>
                                        <span style={{ fontSize: '20px', fontWeight: 'bold', fontStyle: 'italic' }}>
                                            {'Access Notice:'}
                                        </span>
                                    </div>
                                    <div style={{ marginBottom: '8px' }}>
                                        <span style={{ fontSize: '12px', fontWeight: 'bold', fontStyle: 'italic' }}>
                                            {'Official Federal Records - RDS 2200.5.4-a(1)'}
                                        </span>
                                    </div>
                                    <div>
                                        <span style={{ lineHeight: '14px' }}>
                                            {'You are accessing a U.S. Government information system, which includes (1) '}
                                            {'this computer, (2) this computer network, (3) all computers connected to this '}
                                            {'network and (4) all devices and storage media attached to this network or to a '}
                                            {'computer on this network. This information system is provided for U.S. Government-authorized '}
                                            {'use only. Unauthorized or improper use or access of this system may result in '}
                                            {'disciplinary action, as well as civil and criminal penalties. By using this information '}
                                            {'system, you understand and consent to the following:'}
                                        </span>
                                    </div>
                                </Col>
                            </Row>
                            <Row style={{ marginLeft: '-10%' }}>
                                <Col span={16}>
                                    <Row type='flex' justify='space-around' align='middle' gutter={12} style={{ marginTop: '14px' }}>
                                        <Col span={8} style={{ textAlign: 'center' }}>
                                            <Popover
                                                placement='left'
                                                content={<BulletInfo divStyle={{ width: '300px' }} title='Expectation(s)' text={noticeBullets[0]} />}
                                            >
                                                <Card
                                                    hoverable
                                                    bodyStyle={{ padding: '4px' }}
                                                    onClick={() => this.toggleModalView(
                                                        <div>
                                                            <BulletInfo title='Expectation(s)' text={noticeBullets[0]} />
                                                            <CloseButton fn={(arg) => this.toggleModalView(arg)} />
                                                        </div>
                                                    )}
                                                >
                                                    <Icon type='double-right' style={{ marginRight: '5px' }} />
                                                    <span style={{ fontStyle: 'italic' }}>
                                                        {'Expectation(s)'}
                                                    </span>
                                                </Card>
                                            </Popover>
                                        </Col>
                                        <Col span={8} style={{ textAlign: 'center' }}>
                                            <Popover
                                                placement='left'
                                                content={<BulletInfo divStyle={{ width: '300px' }} title='Disclosure' text={noticeBullets[1]} />}
                                            >
                                                <Card
                                                    hoverable
                                                    bodyStyle={{ padding: '4px' }}
                                                    onClick={() => this.toggleModalView(
                                                        <div>
                                                            <BulletInfo title='Disclosure' text={noticeBullets[1]} />
                                                            <CloseButton fn={(arg) => this.toggleModalView(arg)} />
                                                        </div>
                                                    )}
                                                >
                                                    <Icon type='double-right' style={{ marginRight: '5px' }} />
                                                    <span style={{ fontStyle: 'italic' }}>
                                                        {' Disclosure'}
                                                    </span>
                                                </Card>
                                            </Popover>
                                        </Col>
                                        <Col span={8} style={{ textAlign: 'center' }}>
                                            <Popover
                                                placement='left'
                                                content={<BulletInfo divStyle={{ width: '300px' }} title='Authorization' text={noticeBullets[2]} />}
                                            >
                                                <Card
                                                    hoverable
                                                    bodyStyle={{ padding: '4px' }}
                                                    onClick={() => this.toggleModalView(
                                                        <div>
                                                            <BulletInfo title='Authorization' text={noticeBullets[2]} />
                                                            <CloseButton fn={(arg) => this.toggleModalView(arg)} />
                                                        </div>
                                                    )}
                                                >
                                                    <Icon  type='double-right' style={{ marginRight: '5px' }} />
                                                    <span style={{ fontStyle: 'italic' }}>
                                                        {' Authorization'}
                                                    </span>
                                                </Card>
                                            </Popover>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row style={{ marginLeft: '-10%' }}>
                                <Col span={16}>
                                    <AuthTypes ip={this.props.ip} type={authType.indexOf(':') !== -1 ? authType.substring(0, authType.indexOf(':')) : authType} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card>
            </div>
        );
    }
}
